import { DateFromToFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import * as React from "react";

const SentDateFilter = ({ label = "l.searchFilter.sentDate", ...others }: FilterLabelProps) => {
  return <DateFromToFilter label={label} from={"sentDateFrom"} to={"sentDateTo"} {...others} />;
};

export default SentDateFilter;
